module.exports = __webpack_public_path__ + "static/organicseacreatures-a4566640441b28348221c56f0bb67698.jpeg";